import { render, staticRenderFns } from "./effect-table.vue?vue&type=template&id=7ff78c80&scoped=true"
import script from "./effect-table.vue?vue&type=script&lang=js"
export * from "./effect-table.vue?vue&type=script&lang=js"
import style0 from "./effect-table.vue?vue&type=style&index=0&id=7ff78c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff78c80",
  null
  
)

export default component.exports